import { CONSULTATION_TYPE } from './consultation'

export enum NAVIGATOR_AUTHOR {
  PATIENT = 'patient',
  HEALTH_NAVIGATOR = 'healthNavigator'
}

export type HealthResource = {
  name: string
  url: string
}

export enum RATING_TYPE {
  THUMBS = 'thumbs',
  STARS = 'stars'
}

export type UserMessageFeedback = {
  feedbackId?: string
  rating: number // 1-5 for stars, -1/1 for thumbs
  ratingType: RATING_TYPE
  comment?: string
}

export type UserConversationFeedback = {
  feedbackId: string
  rating: number
  ratingType: RATING_TYPE
}

export type PatientAuthorMessage = {
  messageId?: string
  text: string
  sender: NAVIGATOR_AUTHOR.PATIENT
}

export enum MessageRole {
  USER = 'user',
  ASSISTANT = 'assistant',
  SYSTEM = 'system'
}

export enum ActionableType {
  ABI_SERVICE = 'abi_service',
  CLIENT_SERVICE = 'client_service',
  ACTION = 'action'
}

export enum ActionableDomain {
  MEDICAL = 'medical',
  SUPPORT = 'general_support',
  USER = 'user'
}
export type Actionable = {
  type: ActionableType
  name: string
  source: MessageRole
  domain?: ActionableDomain
  referenceUrl?: string
  label?: string
  payload?: Record<string, unknown>
}

export type HealthNavigatorAuthorMessage = {
  messageId?: string
  text: string
  sender: NAVIGATOR_AUTHOR.HEALTH_NAVIGATOR
  recommendedActions?: Actionable[]
  healthResources?: HealthResource[]
  userFeedback?: UserMessageFeedback
}

export type HealthNavigator = {
  messages: (HealthNavigatorAuthorMessage | PatientAuthorMessage)[]
  conversationId?: string
  isFinished?: boolean
  userFeedback?: UserConversationFeedback
}

export enum NAVIGATOR_STATUS {
  PENDING = 'pending',
  RESOLVED = 'resolved'
}

export type HealthNavigatorResponse = {
  navigatorName: string
  partnerName: string
  isFirstTime: boolean
  isServiceSelected: boolean
  status: NAVIGATOR_STATUS

  healthNavigator: HealthNavigator
}
